/*
 * ParentList Messages
 *
 * This contains all the text for the ParentList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.ParentList.header',
    defaultMessage: 'Parent Meetings',
  },
  nonePlanned: {
    id: 'app.components.ParentList.nonePlanned',
    defaultMessage: 'No meetings planned yet',
  },
  registerFrom: {
    id: 'app.components.ParentList.registerFrom',
    defaultMessage: 'Registration starts {date}',
  },
  registerBefore: {
    id: 'app.components.ParentList.registerBefore',
    defaultMessage: 'Register before {date}',
  },
  registrationClosed: {
    id: 'app.components.ParentList.registrationClosed',
    defaultMessage: 'Registration closed',
  },
  registrationNoChange: {
    id: 'app.components.ParentList.registrationNoChange',
    defaultMessage: 'You cannot change the time anymore, the registration is closed',
  },
  videoLinkNoChange: {
    id: 'app.components.ParentList.videoLinkNoChange',
    defaultMessage: 'You cannot change the time anymore, a video conference link has already been added',
  },
  planned: {
    id: 'app.components.ParentList.planned',
    defaultMessage: 'Planned for {date}',
  },
  register: {
    id: 'app.components.ParentList.register',
    defaultMessage: 'Register',
  },
  change: {
    id: 'app.components.ParentList.change',
    defaultMessage: 'Change meeting time',
  },
  assigned: {
    id: 'app.components.ParentList.assigned',
    defaultMessage: 'Assigned by teacher',
  },
  preview: {
    id: 'app.components.ParentList.preview',
    defaultMessage: 'Preview',
  },
  viewAllStudents: {
    id: 'app.components.ParentList.viewAllStudents',
    defaultMessage: 'View meetings for all your children',
  },
  location: {
    id: 'app.components.Planner.location',
    defaultMessage: 'Location',
  },
  onPremises: {
    id: 'app.components.Planner.onPremises',
    defaultMessage: 'On Premises',
  },
  videoMeeting: {
    id: 'app.components.Planner.videoMeeting',
    defaultMessage: 'Video Conference',
  },
  selectLocationType: {
    id: 'app.components.ParentList.selectLocationType',
    defaultMessage: 'Select location',
  },
  joinVideo: {
    id: 'app.components.VideoConf.joinVideo',
    defaultMessage: 'Join Video Conference',
  },
  noLinkYet: {
    id: 'app.components.VideoConf.noLinkYet',
    defaultMessage: 'No video meeting link available yet',
  },
  noLinkYetInfo: {
    id: 'app.components.VideoConf.noLinkYetInfo',
    defaultMessage: 'A video meeting link will become visible here once the teacher adds it',
  },
});
